import { Button, Dropdown, Menu } from '@bedrock/components';
import { ButtonProps } from '@bedrock/components/lib/Button';
import React, { useMemo } from 'react';
import classNames from 'classnames/bind';
import styles from './index.less';
import { ChevronDown } from '@bedrock/icons-react';

const cx = classNames.bind(styles);

type ButtonGroupProps = {
  coverButtonProps: ButtonProps;
  items: {
    key: string;
    show?: boolean;
    tip?: string;
    buttonProps: ButtonProps;
  }[]
}

const DropdownButtonGroup = (props: ButtonGroupProps) => {
  const { coverButtonProps, items } = props
  const showItems = useMemo(() => {
    return items?.filter(item => item?.show) || []
  }, [items])

  if (showItems.length === 1) {
    return <Button {...coverButtonProps} {...showItems[0]?.buttonProps} />
  }

  return (
    <Dropdown overlay={
      <Menu>
        {
          showItems.map(item => {
            const icon = item.buttonProps.icon;
            const tip = item.tip;
            const menuProps = {
              key: item.key,
              onClick: item.buttonProps.onClick,
              disabled: item.buttonProps.disabled,
            }
            
            return <Menu.Item {...menuProps}>
              <div className={cx('menu-item-container')}>
                <div>
                  {icon}&nbsp;&nbsp;
                  {item.buttonProps.children}
                </div>
                <div className={cx('menu-item-container-tip')}>{tip}</div>
              </div>
            </Menu.Item>
          })
        }
      </Menu>
    }>
      <Button {...coverButtonProps} suffixIcon={<ChevronDown className="rock-dropdown-down-arrow-icon" />} />
    </Dropdown>
  )
}

export default DropdownButtonGroup;
